<div class="restaurant-card">
  <div class="restaurant-image" [style.background-image]="'url(' + imageUrl + ')'"></div>
  <div class="restaurant-info" (click)="navigateToRestaurant(id)">
    <p class="info-name">{{ name }}</p>
    <p class="info-description">{{ description }}</p>
  </div>
  <button class="btn-restaurant">
    <mat-icon svgIcon="arrow"></mat-icon>
  </button>
</div>
